import type { TaskInstance } from './task-instance.interface';

export interface cv_TaskOutcome {
    C_TaskOutcome_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    SortOrder: number | null;
    TaskInstance: TaskInstance[];
    TaskOutcome: string;
    Version: number;
}
